var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"participant-list"},_vm._l((_vm.participants),function(participant){return _c('participant-list-item',{key:participant.id,attrs:{"participant":participant,"is-one-participant":_vm.isOneParticipant}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }